import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import ActionTypes from '../../../constants/ActionTypes';
import common, { DEFAULT_INITIAL_STATE } from '../../_common/reducers';
export var INITIAL_STATE = _objectSpread({}, DEFAULT_INITIAL_STATE);
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.AREAS.AREA_TREE_LEVELS.ADD:
      return common.add(state, action);

    case ActionTypes.AREAS.AREA_TREE_LEVELS.ADD_UNRECEIVED:
      return common.addUnreceivedKeys(state, action);

    case ActionTypes.AREAS.AREA_TREE_LEVELS.INDEX.ADD:
      return common.addIndex(state, action);

    case ActionTypes.AREAS.AREA_TREE_LEVELS.SET_ACTIVE_KEY:
      return common.setActive(state, action);

    case ActionTypes.AREAS.AREA_TREE_LEVELS.USE.INDEXED.REGISTER:
      return common.registerUseIndexed(state, action);

    case ActionTypes.AREAS.AREA_TREE_LEVELS.USE.INDEXED.CLEAR:
      return common.useIndexedClear(state, action);

    case ActionTypes.AREAS.AREA_TREE_LEVELS.USE.KEYS.REGISTER:
      return common.useKeysRegister(state, action);

    case ActionTypes.AREAS.AREA_TREE_LEVELS.USE.KEYS.CLEAR:
      return common.useKeysClear(state, action);

    case ActionTypes.AREAS.AREA_TREE_LEVELS.INDEX.CLEAR_ALL:
      return common.clearIndexes(state, action);

    case ActionTypes.COMMON.DATA.SET_OUTDATED:
      return common.dataSetOutdated(state, action);

    case ActionTypes.COMMON.DATA.CLEANUP_ON_LOGOUT:
      return common.cleanupOnLogout(state, action);

    default:
      return state;
  }
});